import { Event, ExtendedEvent } from 'models/Event';
import { addHours } from 'utils/dateManager';

export const formatEvent = (event: Event): ExtendedEvent => {
  const start = new Date(`${event.date} ${event.time}`);
  return {
    ...event,
    end: addHours(start, 1),
    resourceId: event.type,
    start,
  };
};

export const formatEvents = (events: Event[]): ExtendedEvent[] => events.map(
  (event: Event) => formatEvent(event),
);
